import styled, { css } from 'styled-components';

import ControlButton from './subcomponents/ControlButton';
import { Icon as ControlButtonIcon } from './subcomponents/ControlButton/ControlButton.styled';
import { Container as BaseContainer } from '../SupportBlock.styled';

export const Container = styled(BaseContainer)`
    ${({ theme }) => css`
        padding: 1.5rem 1rem;
        width: calc(100% - 0.5rem);

        @media ${theme.breakpoints.smallLarge.media} {
            padding: 1.5rem;
        }
    `}
`;

export const EmblaCarousel = styled.div`
    overflow: hidden;
`;

export const EmblaContainer = styled.div`
    display: flex;
`;

export const Slide = styled.div`
    flex: 0 0 100%;
`;

export const SliderButton = styled(ControlButton)`
    ${({ theme }) => css`
        border: 0.5rem solid ${theme.colors.secondary.tints[0].hex};
        outline: none;

        ${ControlButtonIcon} {
            border: none;
        }
    `}
`;

export const ControlContainer = styled.div`
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
`;

export const Control = styled.div`
    width: 2rem;
    height: 2rem;
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
`;

export const Nav = styled.nav`
    margin-top: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const NavList = styled.ol`
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0 2rem;
`;

export const NavItem = styled.li`
    padding: 0 0.375rem;
    display: block;
`;
